module.exports = __webpack_public_path__ + "assets/img/enterIcon4.56dedd38.png";